import extractLastOptions from "../../../utils/extract-last-options";
import inheritOptions from "./inherit-options";

/**
 * Process steps from string
 * @param {Array<StepProps>} input Array of step Maps
 * @param {MainClassProps} main
 */
const processSteps = (input, main) => {
  /** Step Number */
  let number = 0;

  /**
   * Process each step
   */
  for (const step of input) {
    /** Step data @type {StepsDataProps} */
    const data = new Map([["number", number]]);

    /** Extract last options, if any */
    const extracted = extractLastOptions(step.get("original"));

    /** Common parent (timeline) options */
    const common = /** @type {OptionsListMapProps} */ (
      step.get("common-options")
    );

    /** Get local step options */
    const local = extracted.get("options");

    /** Inherit the options from the parent timeline */
    const result = inheritOptions(common, local, main);

    step.set("original", extracted.get("rest"));
    step.set("options", result);
    step.set("data", data);

    ++number;
  }
};

export default processSteps;
